import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CompanyService } from '../../../service/company.service';
import { UserdataService } from '../../../service/userdata.service';

@Component({
    selector: 'app-settings',
    standalone: false,

    templateUrl: './settings.component.html',
    styleUrl: './settings.component.scss'
})
export class SettingsComponent {
    readonly data = inject<any>(MAT_DIALOG_DATA);
    user: any;
    page: number = 1;
    userBackup: any;


    constructor(
        private dialogRef: MatDialogRef<SettingsComponent>,
        private compService: CompanyService,
        private userService: UserdataService
    ) {
        this.page = this.data.page;
        userService.data.subscribe((data) => {
            this.user = data;
            this.userBackup = { ...this.user };
        });

    }

    async changeCompanyData(data: any) {
        let result = await this.compService.updateCompanyMetaData(data.name, data.industry, data.mission, data.webpage);
        if (result === false) {
            return;
        }
        this.user.companyData = data;
        this.userService.updateUserData(this.user);
    }

    save() {
        this.dialogRef.close();
    }

    async close() {
        await this.userService.updateUserData(this.userBackup);
        this.dialogRef.close();
    }
}
